import { Component, OnInit, Inject, ChangeDetectorRef } from "@angular/core";
import { NewInspectionService } from "../../../inspections/inpsection.service";
import {
  InspectedImplementsViewModel,
  InspectImplementQuestionViewModel,
  InspectImplementAnswersViewModel,
  CommentModelComingFrom,
  QuestionModelComingFrom,
  PhotoModelComingFrom,
} from "../../../inspections/inspection.model";
import { ImplementDetailsService } from "../../../implement-details/implement-details.service";
import { LastInspectionDetailsForImplementModel } from "../../../implement-details/implement-details";
import { Validators, FormGroup, FormControl } from "@angular/forms";
import {
  OrdinalDateAdapter,
  ORD_DATE_FORMATS,
} from "../../../adapters/ordinal-date-adapter";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "../../../../../translate";
import { AppService } from "../../../../../app.service";
import {
  Customer,
  JobSite,
  SelectionLists,
} from "../../../../GET_NEW_UI/entities/global/model";
import { GETGenericIdName } from "../../../setup-implement/setup-implement.model";
import { Router } from "@angular/router";
import { GETSetupEquipmentService } from "../../../setup-equipment/setup-equipment.service";
import { DatePipe } from "@angular/common";
import { NotificationsService } from "angular2-notifications";
import { LoadingService } from "../../../shared/loading.service";
import { DomSanitizer } from "@angular/platform-browser";
import { ImplementForEquipmentDetails, SchematicAndObservationPointDetails } from "../../equipment-details.model";
import { GETPreferencesService } from "../../../preferences/preferences.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-perform-inspection",
  templateUrl: "./perform-inspection.component.html",
  styleUrls: ["./perform-inspection.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: OrdinalDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: ORD_DATE_FORMATS,
    },
  ],
})
export class PerformInspectionComponent implements OnInit {
  implementId: number;
  CustomerId: number;
  CustomerName: string;
  jobsiteId: number;
  jobsiteName: string;
  implementName: string;
  hasImplement: boolean = false;
  minDate: Date = new Date();
  maxDate: Date = new Date();
  inspectionDate: Date = new Date();
  lastInspectionDetails: LastInspectionDetailsForImplementModel;
  GeneralQuestion: InspectedImplementsViewModel[];
  smu: number;
  preSmu: number;
  ttDate: string = "Click here to select a date.";
  smuForm: FormGroup;
  smuReadingInput: FormControl;
  userLanguage = "english";
  translateSubscription: Subscription;
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  selectedCustomer: Customer;
  selectedJobsite: JobSite;
  selectedJobsiteFromHeader: JobSite = new JobSite();
  selectedJobsiteId: number;
  isLoading: boolean = false;
  Customer: string;
  Jobsite: string;
  implementList: GETGenericIdName[] = [];
  implementListFiltered: GETGenericIdName[] = [];
  selectedImp: any;
  selectedImpId: number = 0;
  customerId: number = 0;
  equipmentId: number = 0;
  selected_date: Date = new Date();
  stringDate: string;
  implementToBeInspected: InspectedImplementsViewModel;
  reloadFinish: boolean = false;
  originalCopy: InspectedImplementsViewModel;
  userPref: string;
  implementImage: any;
  IsOnEquipment: boolean = false;
  commentComingFrom: CommentModelComingFrom;
  questionComingFrom: QuestionModelComingFrom;
  inspectionImages: PhotoModelComingFrom;
  inspectiongeneralQuestionImage: PhotoModelComingFrom;
  observationImagesOnObservation: PhotoModelComingFrom;
  ImplementForEquipmentDetails: ImplementForEquipmentDetails[] = [];
  UnitNumber: string = "";
  selectedSchematic: number = -999;
  SchematicAndObservationPointList: SchematicAndObservationPointDetails[];
  saving: boolean = false;
  submitted: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<PerformInspectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _inspectionService: NewInspectionService,
    private _implementService: ImplementDetailsService,
    private _translate: TranslateService,
    private _appService: AppService,
    private _equipmentService: GETSetupEquipmentService,
    private router: Router,
    private datePipe: DatePipe,
    private _toaster: NotificationsService,
    //private _loadingService: LoadingService,
    private _sanitizer: DomSanitizer,
    private _getPrefrencesService: GETPreferencesService,
    private ref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.implementId = this.data.implementId;
    this.CustomerId = this.data.CustomerId;
    this.CustomerName = this.data.CustomerName;
    this.jobsiteId = this.data.jobsiteId;
    this.jobsiteName = this.data.jobsiteName;
    this.implementName = this.data.implementName;
    if (this.data.implementId > 0) {
      this.hasImplement = true;
      this.getLastInpectiondetails();
    }
    if (this.data.linkId > 0) {
      this.loadCustomers();
    }
    this._inspectionService.GetImplementQuestions().subscribe((result) => {
      console.log(result);
      this.GeneralQuestion = result;
    });

    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
  }

  getLastInpectiondetails() {
    this._implementService
      .GetLastInspectionDetailsForImplement(this.implementId)
      .subscribe((res) => {
        console.log(res);
        this.lastInspectionDetails = res;
        this.minDate = res.InspectioDate;
        this.preSmu = res.SMU;
        this.createFormControls(this.preSmu);
        this.createForm();
      });
  }

  loadCustomers() {
    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      (result) => {
        this._dropDownLists.customerList = result;
        this._dropDownListsFiltered.customerList = result;
        this.loadJobsitesForCustomer();
      },
      (error) => {
        console.error(error);
      },
      () => {},
    );
  }

  loadJobsitesForCustomer() {
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(
      (result) => {
        this._dropDownLists.jobSiteList = result;
        this._dropDownListsFiltered.jobSiteList = result;
      },
      (error) => {
        console.error(error);
      },
      () => {},
    );
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  smuChanged() {
    this.createFormControls(this.preSmu);
    if (this.smu < this.preSmu) {
    }
  }
  smuReadingInputValidation() {
    return this.smu < this.preSmu;
  }
  inputSMUErrorMessage() {
    return this.smuReadingInput.hasError("required")
      ? "You must enter a value"
      : "";
  }

  createFormControls(preChangeSMU: number) {
    console.log("pre", this.preSmu);
    this.smuReadingInput = new FormControl("", [
      Validators.required,
      Validators.min(preChangeSMU),
    ]);
  }
  createForm() {
    this.smuForm = new FormGroup({
      smuReadingInput: this.smuReadingInput,
    });
  }

  answered(
    question: InspectImplementQuestionViewModel,
    answers: InspectImplementAnswersViewModel,
    event: any,
  ) {
    //question.Answer = event;
    console.log(question, answers, event);

    let ans = question.PossibleAnswers.find((x) => x.Id == event);
    question.Answer = ans;

    console.log(" question.Answer", question.Answer);
    // if (this.isCreatingInspection) {
    //   question.Answer = answers;
    // } else {
    //   this._loadingService.startLoading();
    //   this._inspectionService.ChangedImplementGeneralQuestion(this.implementToBeInspected.ImplementInspectionId, question, answers)
    //   .subscribe(r => {
    //     this._loadingService.finishedLoading();
    //     console.log(r);
    //   });
    // }
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    console.log("language", this.userLanguage)
    this.ref.detectChanges();
  }

  customerChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this._dropDownListsFiltered.customerList =
        this._dropDownLists.customerList.filter((option) =>
          option.Title.toLowerCase().includes(filterValue),
        );
    }
    else {
     this.customerId = 0;
     this.selectedCustomer = null;
     this.Jobsite = null;
     this.selectedJobsite = null;
     this.jobsiteId = 0;
     this._dropDownListsFiltered.jobSiteList = [];
     this.selectedImp = null;
     this.selectedImpId = 0;
     this.implementList = [];
     this.implementListFiltered = [];
    } 
  }

  onSelectCustomer(event: any) {
    let id = this._dropDownListsFiltered.customerList.find(
      (f) => f.Title == event.value,
    ).Id;
    this.selectedCustomer = event.value;
    this.customerId = id;
    this._dropDownListsFiltered.jobSiteList = null;
    this._dropDownListsFiltered.jobSiteList =
      this._dropDownLists.jobSiteList.filter((m) => m.CustomerId === id);
  }

  jobsiteChanged(event: any): void {
    this.selectedJobsite = event.value;
    if (!this.selectedJobsite) {
      this.jobsiteId = 0;
      this.selectedImp = null;
      this.selectedImpId = 0;
      this.implementList = [];
      this.implementListFiltered = [];
      return;
    }
    this.jobsiteId = this.selectedJobsite.Id;
    this.loadAssets();
  }

  loadAssets() {
    if (!this.jobsiteId) {
      return;
    }
    this._equipmentService.getImpsByJobsite(this.jobsiteId).subscribe((r) => {
      if (r) {
        this.implementList = r;
        this.implementListFiltered = r;
      }
    });
  }
  selectUnitNumber(impId: number) {
    this.selectedImpId = impId;
    const selected = this.implementList.find((x) => x.Id === impId);
    this.equipmentId = selected.EquipmentId;
    if (selected) {
      this.selectedImp = selected.Name;
      this.getImpData();
    }
    console.log("Selected Asset Id:", this.selectedImpId);
  }

  filterUnitNumbers(value: string) {
    if (!value) {
      this.implementListFiltered = this.implementList;
      return;
    }
    const filterValue = value.toLowerCase();
    this.implementListFiltered = this.implementList.filter((imp) =>
      imp.Name.toLowerCase().includes(filterValue),
    );
  }

  getDate(event) {
    this.selected_date = event.target.value;
    this.stringDate = this.datePipe.transform(this.selected_date, "MM/dd/yyyy");
    this.implementToBeInspected.InspectionDate = this.selected_date;
    this.implementToBeInspected.InspectionStringDate = this.stringDate;
    console.log('Date', this.stringDate, this.selected_date);
  }

  onSMUChange() {
    this.implementToBeInspected.MeterReading = this.smu;
  }

  getImpData() {
    //console.log("this.EquipmentID, this.selectedImplmentId", this.EquipmentID, this.selectedImplmentId);
    //this._loadingService.startLoading();
    if (this.selectedImpId === undefined) {
      //this._loadingService.finishedLoading();
      this.reloadFinish = true;
      return;
    }
    if (this.equipmentId > 0) {
      this._inspectionService
        .GetInspectionTemplatesBySelectedImplementId(this.selectedImpId)
        .subscribe((r) => {
          this.implementToBeInspected = r;
          console.log(
            "this.implementToBeInspected",
            this.implementToBeInspected,
          );
          this.getUserPref();
          //console.log(this.implementToBeInspected);
          // this.ImplementID = this.implementToBeInspected.ImplementId
          // this.implementInspectionID = this.implementToBeInspected.ImplementInspectionId
          // this.currentSMU = this.implementToBeInspected.MeterReading;
          this.loadImplementImage();
          this.loadImplementDetails();
          //if (this.implementToBeInspected.EquipmentId == 0)
          //  this.IsOnEquipment = false;
          //else
          this.IsOnEquipment = true;
          this.GetSequentialNumber();
          this.implementToBeInspected.InspectionDate = new Date();
          this.originalCopy = r;
          this.viewImplementLevel();
          //this._loadingService.finishedLoading();
          this.reloadFinish = true;
          console.log(this.implementToBeInspected.GeneralQuestions);
          this.implementToBeInspected.GeneralQuestions.forEach((question) => {
            if (
              question.PossibleAnswers &&
              question.PossibleAnswers.length > 0
            ) {
              if (question.Id == 3)
                question.Answer = question.PossibleAnswers.find(
                  (f) => f.Id == 7,
                );
              else if (question.Id == 4)
                question.Answer = question.PossibleAnswers.find(
                  (f) => f.Id == 10,
                );
              else if (question.Id == 5)
                question.Answer = question.PossibleAnswers.find(
                  (f) => f.Id == 12,
                );
            }
          });
        });
    } else {
      this._inspectionService
        .GetInspectionTemplatesBySelectedImplementIdOnInventory(
          this.selectedImpId,
        )
        .subscribe((r) => {
          // console.log(r);
          this.implementToBeInspected = r;
          this.getUserPref();
          // this.ImplementID = this.implementToBeInspected.ImplementId
          // this.implementInspectionID = this.implementToBeInspected.ImplementInspectionId
          // this.currentSMU = this.implementToBeInspected.MeterReading;
          this.loadImplementImage();
          this.loadImplementDetails();
          this.implementToBeInspected.InspectionDate = new Date();
          this.originalCopy = r;
          this.viewImplementLevel();
          //this._loadingService.finishedLoading();
          this.reloadFinish = true;
          this.IsOnEquipment = false;
          this.GetSequentialNumber();
          this.implementToBeInspected.GeneralQuestions.forEach((question) => {
            if (
              question.PossibleAnswers &&
              question.PossibleAnswers.length > 0
            ) {
              if (question.Id == 3)
                question.Answer = question.PossibleAnswers.find(
                  (f) => f.Id == 7,
                );
              else if (question.Id == 4)
                question.Answer = question.PossibleAnswers.find(
                  (f) => f.Id == 10,
                );
              else if (question.Id == 5)
                question.Answer = question.PossibleAnswers.find(
                  (f) => f.Id == 12,
                );
            }
          });
        });
    }
    this.commentComingFrom = CommentModelComingFrom.NewInspection;
    this.questionComingFrom = QuestionModelComingFrom.NewInspection;
    this.inspectionImages = PhotoModelComingFrom.NewInspectionInspectionImages;
    this.inspectiongeneralQuestionImage =
      PhotoModelComingFrom.NewInspectionGeneralQuestionsImagesOnImplementLevel;
    this.observationImagesOnObservation =
      PhotoModelComingFrom.NewInspectionObservationPointImageOnComponentLevel;

    //this._loadingService.finishedLoading();
    this.reloadFinish = true;
    this.commentComingFrom = CommentModelComingFrom.Interpretation;
    this.inspectionImages = PhotoModelComingFrom.InterpretationInspectionImages;
    this.inspectiongeneralQuestionImage =
      PhotoModelComingFrom.InterpretationGeneralQuestionsImagesOnImplementLevel;
    this.observationImagesOnObservation =
      PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel;
    this.viewImplementLevel();
  }

  loadImplementImage() {
    if (this.implementToBeInspected.ImplementsImage)
      this.implementImage = this.getImage(
        this.implementToBeInspected.ImplementsImage,
      );
    else {
      let SampleImage =
        "iVBORw0KGgoAAAANSUhEUgAAAHgAAABOCAIAAABkJUU1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTZEaa/1AAAFN0lEQVR4Xu2c2VYiMRRF/f//sx1abWdEcBabx95w0rWKqlRRQyYg+4FlgKWyc+omuaBHk8nk4+NjuVz+zfjh/f396enpiK9eXl6m0+lisdADGVegFLGvr6/keCVad2Ed9xpmxoNfLP/8/GhoRIu3tzce+/7+NuPMIL6+vtBIQTbjNRuiQWnHuBln+kB+qcOz2awIckFVtGA20M3MmHGmA5+fn5Rfbs14E7toYE6YGQpNfXIyFVA0X9PiqlG0YH5ytNtRkLcq2iIaukzXYYIQLnqKchcz20WL9gJ0gHQMckFX0cC8NS2pB0WvIBf0EC20STzYaHOmG7Zo9RYtKNmHFm1e7PPzM0E2454MFA3MKkWqcv7ZVxTkMWfm4aIFM8w873G0XR2Vx4oG5plo72VDqtIYGoMD0YI5J9p702slPSh2mB5noqFov5rxzuKjHroULQZvgFLA3wrvXjQUO6EdWiT5Vb0u7F5Ei76H1IgEaDB4FA2kg3NNyg2pYL+hX9GCpKRZtUO+vxFCNJCXVad1Pjfj2CjIIVeRQKKFou21FHYhyr4oqGhQlMCMw8JP13bIjAMSWrTQKh+4ITW+MTSGOKKF9q0BTu0pHFljiobuvbFlA+bhZvSpoGCLXhORRQs1pAoXRmFJIvNxdXX1u8bFxUXLmqbG0PgOpxOSEA1YxiZyMf7nP0URp6D/auD29lbPKcN383qeHkAqogWiHx4ejo+PMXh6eqouJRNwdnYmrXVOTk4qoUYuu5rU3vpJTjQxnEwmKC7CyNBIXYNZMIM1d3d3PNmKvkMKpCW6AEe4RjGlWVq5pUqwcyC/QOW9v78n9XLNF3V4frnQxyUh0cjleqccU52pFeXYsu5VSoEMYpyZME+qcX19nUVbYIdgDG2CZYTyBG6p4JeXl2w2KBdSz/Q0uc6i7ZBlLYMVdNDgtrIkEnkKOg9xzqxUbZFF27GKJr88RJatGw/8Ktc3NzfmrhJZtB2raO5E1uPjoxnXQDFPYNdsxiWyaDtW0aobLSve+fk5TyDXZlwii7bTIpoCYsY1JJoybcYlsmg7VtFsRZDFltmMa7AXzKWjH1bRFA0eIrAcQMxdm6hnxNnEjEtk0XasotlXSOVsNqvv4VgkUZm3d/2wigYOLHpbhBWPPQZFGUi6yjcHlqYKnkXbaRINuFYnrwL765Z1Mou20yIaKA6IY9GjUABx5hTeVLhFFm2nXXQBxq0VuU4WXYWELhYLlju9O+UKNoVZtIGlDL9eP8HEEprCJ6RiikYB5YI4m7E3+BH8IPVaYxFHNEF+DvuJIV06YMbBiSCajVqsfCnaAa6hOkFFs+IRZB00IkLJJtpk3IyDEE40J+lpMv8iS3+ypzcNwhBCNHLT+cRQGa4trrAwc+9dNC8Gy4Gv0+4EC4FH0bo8rT2K1FBZ8/qJXi+iyW9qH33biu+F2r1o9m2xtlDj0RnKR7Rdiia/q78H2vH/vsQvz+aPK9Ltq3AmmghT5nY0yHWINi/H4anKgWhFYNeDXIeq7TDaY0UHawzFQi9wfLSHi2aeWaYJshnvL8Ula8aDGCja1TzvEFy1Y67d3qIV5JAdzqQg18MaUv1Eq8Pp9QSVPjoo9D3xdhWNXLY70Tuc6aAeTveGVCfRagU42eXsE1gm2h0bUltEK8g70RiKhVK4NdqNoskvK96wwn9oYBnX7dG2i97pxlAsuO7R3bRTqIomv4N3MBmi3dRr3RA9ck+eEdaGlBGtIEMOshOIthpSZizROcieKDcqjsa3SzItUCFWhufzf5LmIP5DdRB8AAAAAElFTkSuQmCC";
      this.implementToBeInspected.ImplementsImage = SampleImage;
      this.implementImage = this.getImage(SampleImage);
    }
  }

    getImage(image: string) {
    if (image != null && image !== undefined) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
    }
  }


  loadImplementDetails() {
    this.isLoading = true
    this._implementService.getSchematicsImagesForImplement(this.selectedImpId).subscribe(details => {
      this.ImplementForEquipmentDetails = details;
      this.SchematicAndObservationPointList = this.ImplementForEquipmentDetails[0].SchematicAndObservationPoints
      //this.SchematicAndObservationPointList = details[0].SchematicAndObservationPoints;
      this.isLoading = false
    });
  }

  viewImplementLevel() {
    this.selectedSchematic = -999;
    if (this.implementToBeInspected.Components) {
      this.implementToBeInspected.Components.forEach(c => {
        c.ObservationPointsFiltered = c.ObservationPoints;
      });
    }
  }

  GetSequentialNumber() {
    this._inspectionService.GetSequentialNumber().subscribe((result) => {
      if (result != null) {
        const currentYear: number = new Date().getFullYear();
        this.implementToBeInspected.JobFileNo =
          "JF-" +
          currentYear +
          "-" +
          result.toString().padStart(4, "0") +
          (this.UnitNumber !== undefined ? "-" + this.UnitNumber : "");
        this.implementToBeInspected.RepairRequestNo =
          "RR-" +
          currentYear +
          "-" +
          result.toString().padStart(4, "0") +
          (this.UnitNumber !== undefined ? "-" + this.UnitNumber : "");
      }
    });
  }

  getUserPref() {
    this._getPrefrencesService.getUserPreferences().subscribe((r) => {
      this.userPref = r.UnitOfMeasurementName;
      console.log("userPref", this.userPref);
    });
  }


  // createNewInspection() {
  //   const equipmentId = this.equipmentId;
  //   const implementId = this.selectedImpId;
  //   this.dialogRef.close();
  //   this.router.navigate(["/get-inspection", equipmentId, implementId]);
  // }

  createNewInspection() {
    this.submitted = true;
    this.isLoading = true;
    this.implementToBeInspected.MeterReading = this.smu;
    this._inspectionService
      .saveNewImplementInspection(this.implementToBeInspected)
      .subscribe((r: any) => {
        //this._toaster.setRootViewContainerRef(this.vcr);
        // console.log("r", r)
        if (r.m_Item1 > 0) {
          this._toaster.success("Saved Inspection successfully");
          setTimeout(() => {
            this.dialogRef.close();
            this.isLoading = false;
            this.submitted = false;
            //this._touter.navigate(['equipment/', + this.equipmentId]);
            // this._touter.navigate(['in/', + this.equipmentId]);
            if (this.equipmentId > 0)
              this.router.navigate([
                "/get-interpretation/inspection",
                this.equipmentId,
                r.m_Item1,
              ]);
            else
              this.router.navigate([
                "/get-interpretation/inspection",
                0,
                r.m_Item1,
              ]);
          }, 2000);
        } else {
          this.submitted = false;
          this.isLoading = false;
          this._toaster.error(
            "Failed to Save, SMU needs to be greater than " + r.m_Item2,
          );
        }
      });
  }
}
